import { useTickets } from 'contexts/TicketsContext';
import { TicketsRefinementKeysE } from 'declarations/enums/tickets';
import type { ClaimReportCardI } from 'declarations/interfaces/reports';
import { useFetchClaimReports } from 'hooks/api/useReports';

type UseDealerReportT = {
  claimReport: ClaimReportCardI[] | null;
  isLoadingReport: boolean;
};

const useDealerReport = (): UseDealerReportT => {
  /**
   * Hooks
   */
  const { getSearchParam } = useTickets();

  /**
   * Api hooks
   */
  const claimReportResult = useFetchClaimReports({
    roofTopId: getSearchParam(TicketsRefinementKeysE.RoofTopId) || undefined,
  });

  return {
    claimReport: claimReportResult.data ? claimReportResult.data : null,
    isLoadingReport: claimReportResult.isLoading || claimReportResult.isRefetching,
  };
};

export default useDealerReport;
